export default __webpack_public_path__ + "static/media/Adriano Spadaro.c9cf572e.jpg";